/**
 * Find the max value in an immutable collection, with a replacement value for NaN.
 *
 * @param immutableIterable {Immutable.Iterable<any, number>} an iterable immutable object.
 * @param replaceNaNWith {number} number to replace NaN with. Default is 0.
 * @returns {number} the max value in the given iterable, with any NaNs considered as equivalent
 * to replaceNaNWith
 */
export function maxByReplacingNaN(immutableIterable, replaceNaNWith = 0) {
  return immutableIterable.maxBy(value => (Number.isNaN(value) ? replaceNaNWith : value));
}

/**
 * Sort an immutable collection, replacing NaN with a given value for comparison purposes only (it
 * remains in the result).
 *
 * @param immutableIterator {Immutable.Iterable<any, any>} an iterable immutable object.
 * @param mapper {function(any): number} function mapping an element of the collection to the value
 * that should be used for comparison in sorting.
 * @param replaceNaNWith {any} if mapper returns NaN, compare using this value instead. Default is
 * 0.
 * @returns {Immutable.Iterable<any, any>} a sorted copy of the given collection.
 */
export function sortByReplacingNaN(immutableIterator, mapper, replaceNaNWith = 0) {
  return immutableIterator.sortBy(value => {
    const mapped = mapper(value);
    return Number.isNaN(mapped) ? replaceNaNWith : mapped;
  });
}
